import { status, type StatusVariant } from './tokens'

export interface LegacyTone {
  bg: string
  color: string
}

// Os mapas de estado dos domínios ainda usam pares da paleta Tailwind; a cor do
// texto diz a semântica, e o StatusChip pinta-a com os tokens (pares AA).
const LEGACY_VARIANT: Record<string, StatusVariant> = {
  '#065F46': 'success', '#15803D': 'success', '#166534': 'success',
  '#92400E': 'warning', '#9A3412': 'warning', '#C2410C': 'warning', '#B45309': 'warning', '#854D0E': 'warning',
  '#991B1B': 'danger', '#B91C1C': 'danger', '#9F1239': 'danger', '#BE185D': 'danger',
  '#1D4ED8': 'neutral', '#1E40AF': 'neutral', '#3730A3': 'neutral', '#4338CA': 'neutral', '#374151': 'neutral',
  '#5B21B6': 'info', '#7E22CE': 'info', '#155E75': 'info', '#0369A1': 'info', '#075985': 'info',
  '#6B7280': 'muted', '#9CA3AF': 'muted',
  // As próprias cores dos tokens, para mapas que já as usam.
  ...Object.fromEntries(Object.entries(status).map(([variant, tone]) => [tone.fg.toUpperCase(), variant as StatusVariant])),
}

/**
 * Pares {bg, color} prontos a usar nos mapas de estado dos domínios (ex.:
 * `PAGA: TONE.success`) — a mesma forma que os mapas já tinham, com as cores dos tokens.
 */
export const TONE = Object.fromEntries(
  Object.entries(status).map(([variant, tone]) => [variant, { bg: tone.bg, color: tone.fg }]),
) as Record<StatusVariant, LegacyTone>

/** Variante semântica de um par antigo {bg, color}; `null` se a cor não for conhecida. */
export function toneToVariant(tone: LegacyTone): StatusVariant | null {
  return LEGACY_VARIANT[tone.color.toUpperCase()] ?? null
}
